import * as React from "react";

import {
  BreadcrumbCrumbDescription,
  useProductListPresentationModel,
  useReactPlpInitialState,
} from "../providers";

type Breadcrumb = BreadcrumbCrumbDescription & {
  key: string;
};

export const Breadcrumbs: React.FunctionComponent = () => {
  const { initialState } = useReactPlpInitialState();

  const { hasTheSearchTermBeenRedirected } = useProductListPresentationModel();

  const breadcrumbsAsArray = React.useMemo(() => {
    let crumbs: Breadcrumb[] = [];
    for (const [key, crumb] of Object.entries(
      initialState.breadcrumbsDescription?.crumbs || {}
    )) {
      crumbs = [
        ...crumbs,
        ...[
          {
            ...crumb,
            key,
          },
        ],
      ];
    }

    if (hasTheSearchTermBeenRedirected) {
      crumbs[crumbs.length - 1].label = crumbs[
        crumbs.length - 1
      ]?.label?.replace(/Search results for:/, "Search results not found for:");
    }

    return crumbs;
  }, [initialState, hasTheSearchTermBeenRedirected]);

  const items = React.useMemo(() => {
    return (
      <ul className="items">
        {(breadcrumbsAsArray || []).map((crumb) => {
          return (
            <li key={crumb.key} className={`item ${crumb.key}`}>
              {crumb.link ? (
                <a href={crumb.link} title={crumb.title}>
                  {crumb.label}
                </a>
              ) : crumb.last ? (
                <strong>{crumb.label}</strong>
              ) : (
                crumb.label
              )}
            </li>
          );
        })}
      </ul>
    );
  }, [breadcrumbsAsArray]);
  return <div className="breadcrumbs">{items}</div>;
};
